import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { QueryBuilderComponent, QueryBuilderConfig, Rule } from 'ngx-angular-query-builder';

@Component({
  selector: 'mojo-query-builder',
  templateUrl: './query-builder.component.html',
  styleUrls: ['./query-builder.component.scss']
})

export class MojoQueryBuilderComponent implements OnInit {

  @Input() title;
  @Input() query;
  @Input() config: QueryBuilderConfig = { fields: {} };
  @Input() allowRuleset;

  constructor() { }

  ngOnInit() {

    }

  getOptions(rule: Rule) {
    const field: string = rule.field;
    this.workaroundForCoerceValueForOperatorBug(rule);
    return this.config.fields[field].options || [];
  }

  /**
   * There is a bug in ngx-angular-query-builder
   * in the method coerceValueForOperator
   * https://github.com/raysuelzer/ngx-angular-query-builder/blob/feature/angular-17/projects/ngx-angular-query-builder/src/lib/query-builder/query-builder.component.ts
   * which is enclosing an undefined or null
   * value as an element in an array causing an unwanted hidden
   * initial selection of that invalid 1 item in the multi-select.
   * It also does not convert back from an array to a scalar when
   * the operator changes in that direction, but that is another
   * bug not addressed here.
   * This can be observed by opening ngx-angular-query-builder.mjs
   * in chrome dev tools and setting breakpoints in that area.
   * @param rule
   */
  workaroundForCoerceValueForOperatorBug(rule: Rule) : void {
    if (rule?.value?.length &&
          (rule.value[0] === undefined || rule.value[0] === null)) {
      rule.value.splice(0, 1);
    }
  }

}
